module.exports = __webpack_public_path__ + "static/media/2.4067d67e.jpg";